/**
 * Created by pajicv on 10/8/18.
 */
import React from 'react';
import { TextField, withStyles } from '@material-ui/core';
import { updateTaskDescription } from '../../firebase/db';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 40,
    width: 400
  },
});

class TaskDescriptionField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: props.description
    };
  }

  handleChange = (e) => {
    this.setState({
      description: e.target.value
    });
  };


  componentDidUpdate(prevProps, prevState) {
    if (prevProps.description !== this.props.description) {
      this.setState({
        description: this.props.description,
      })
    }
  }

  handleBlur = () => {
    const { taskId } = this.props;
    const { description } = this.state;
    updateTaskDescription(taskId, description);
  };

  componentWillUnmount() {
    if (this.state.description !== this.props.description) {
      updateTaskDescription(this.props.taskId, this.state.description);
    }
  }

  render() {
    const { description } = this.state;
    const { worker, classes } = this.props;
    return (
      <TextField
        label="Beschreibung"
        multiline
        rows="4"
        variant='outlined'
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}

        disabled={worker}
        margin="normal"
        value={description}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
      />
    );
  }
}

export default withStyles(styles)(TaskDescriptionField);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskDescriptionField.js